/** Regnummer från API kan vara null. Listan ska visa raden ändå. */
export function registrationLabel(value: unknown): string {
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  return '';
}
